import React from "react";
import { v4 as uuidv4 } from "uuid";

export default () => {
  return <hr key={uuidv4()} className="border-t border-gray-200" />;
};
